// Обёртка над localStorage: JSON-сериализация + защита от падений
// (приватный режим, переполнение, битые данные).
export default class StorageLocal {
    static Set(key, value) {
        try {
            localStorage.setItem(key, JSON.stringify(value));
        } catch (error) {
            // localStorage недоступен — работаем без персистентности
        }
    }

    static Get(key, defaultValue = null) {
        try {
            const raw = localStorage.getItem(key);
            if (raw === null) return defaultValue;
            return JSON.parse(raw);
        } catch (error) {
            return defaultValue;
        }
    }

    static Remove(key) {
        try {
            localStorage.removeItem(key);
        } catch (error) {
            // ignore
        }
    }
}
